import React, { useState, useEffect, useRef } from "react";
import Swal from "sweetalert2";

import SideBar from "../../components/Sidebar";

import ProfileService from "../../services/ProfileService";
import LoadingScreen from "../../components/LoadingScreen/LoadingScreen";
import BalanceSection from "./BalanceSection";
import { APP_INFO } from "../../constants/AppInfo";

const Profile = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState();

  const [gender, setGender] = useState();

  const nameRef = useRef();
  const emailRef = useRef();

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true);

    try {
      const result = await ProfileService.fetch();

      if (!result.success) {
        Swal.fire("Opps!", result.message, "error");
        return;
      }

      const responseData = result.data;

      if (responseData.status === "SUCCESS") {
        var data = responseData.data;
        setData(data);
        setGender(data.gender);
      } else {
        Swal.fire("Opps!", responseData.message, "error");
      }
    } catch (error) {
      Swal.fire(
        "Opps!",
        "Request Failed:",
        error.response?.data || error.message,
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  const updateProfileHandler = async () => {
    const name = nameRef.current.value;
    const email = emailRef.current.value;

    if (!gender) {
      Swal.fire("Opps!", "Please Select Gender", "error");
      return;
    }

    if (!name) {
      Swal.fire("Opps!", "Please Enter Name", "error");
      return;
    }

    if (!email) {
      Swal.fire("Opps!", "Please Enter Email Address", "error");
      return;
    }

    setLoading(true);

    try {
      const result = await ProfileService.updateBasic(name, email, gender);

      if (!result.success) {
        Swal.fire("Opps!", result.message, "error");
        return;
      }

      const responseData = result.data;

      if (responseData.status === "SUCCESS") {
        Swal.fire("Success!", responseData.message, "success");
      } else {
        Swal.fire("Opps!", responseData.message, "error");
      }
    } catch (error) {
      Swal.fire(
        "Opps!",
        "Request Failed:",
        error.response?.data || error.message,
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid mt-3">
      {loading && <LoadingScreen />}

      <div className="row">
        <SideBar />
        <div className="col-md-9 mb-3">
          {/* Wallet and Cashback Info */}
          <BalanceSection />
          {/* Profile Info */}
          <div className="card mb-4 shadow-sm">
            <div className="card-body">
              <h5 className="card-title">Profile Information</h5>
              <div className="row">
                {/* Left Form */}
                <div className="col-md-6">
                  {data && (
                    <form>
                      {/* <div className="form-group mb-3 mt-3">
                        <div>
                          <div className="form-check form-check-inline">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="gender"
                              value="Male"
                              checked={gender === "Male"}
                              onChange={(e) => setGender(e.target.value)}
                            />

                            <label className="form-check-label">Male</label>
                          </div>
                          <div className="form-check form-check-inline">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="gender"
                              value="Female"
                              checked={gender === "Female"}
                              onChange={(e) => setGender(e.target.value)}
                            />

                            <label className="form-check-label">Female</label>
                          </div>
                        </div>
                      </div> */}

                      <div className="form-group mb-3">
                        <label>User Type</label>
                        <input
                          type="text"
                          className="form-control"
                          defaultValue={data.user_type}
                          readOnly
                        />
                      </div>

                      <div className="form-group mb-3">
                        <label>Name</label>
                        <input
                          type="text"
                          className="form-control"
                          name="name"
                          defaultValue={data.name}
                          ref={nameRef}
                          required
                          readOnly
                        />
                      </div>

                      <div className="form-group mb-3">
                        <label>Mobile Number</label>
                        <input
                          type="text"
                          className="form-control"
                          value={data.mobile}
                          readOnly
                        />
                        <small>
                          To update your mobile number, please send a request to
                          our support team at {APP_INFO.email}.
                        </small>
                      </div>

                      <div className="form-group mb-3">
                        <label>Email</label>
                        <input
                          type="email"
                          className="form-control"
                          name="email"
                          defaultValue={data.email}
                          ref={emailRef}
                          required
                          readOnly
                        />
                        <small>
                          To update your email ID, please send a request to our
                          support team at {APP_INFO.email}.
                        </small>
                      </div>

                      <div className="form-group mb-3">
                        <label>KYC Status</label>
                        <input
                          type="text"
                          className="form-control"
                          value={data.kyc_status}
                          readOnly
                        />
                      </div>

                      <div className="form-group mb-3">
                        <label>Account Status</label>
                        <input
                          type="text"
                          className="form-control"
                          value={data.status}
                          readOnly
                        />
                      </div>

                      <div className="form-group mb-3">
                        <label>Registration Date</label>
                        <input
                          type="text"
                          className="form-control"
                          value={data.created_on}
                          readOnly
                        />
                      </div>

                      {/* <div className="text-center">
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={updateProfileHandler}
                        >
                          Update Profile
                        </button>
                      </div> */}
                    </form>
                  )}
                </div>

                {/* Right Section */}
                <div className="col-md-6">
                  <div className="card shadow-sm mb-3">
                    <div className="card-body">
                      <h6 className="card-title text-dark">
                        We value your privacy
                      </h6>
                      <p className="text-muted mb-0">
                        We will not sell or distribute your contact information.{" "}
                        <a href="/privacy-policy">Read our Privacy Policy</a>.
                      </p>
                    </div>
                  </div>

                  <div className="card shadow-sm">
                    <div className="card-body">
                      <h6 className="card-title text-dark">Need assistance?</h6>
                      <p className="text-muted mb-0">
                        Our <a href="/support">support team</a> is here to help
                        — feel free to reach out.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>{" "}
          {/* end card */}
        </div>{" "}
        {/* end col-md-9 */}
      </div>
    </div>
  );
};

export default Profile;
